<template>
	<b-container fluid>
		<b-row>
			<b-col sm="12">
				<card>
					<template v-slot:headerTitle>
						<h4 class="card-title">Sessions</h4>
					</template>
					<template v-slot:headerAction>
						<div class="float-right">
							<b-button v-b-modal.session-modal variant="primary" class="btn-sm">Add Session</b-button>
						</div>
					</template>
					<template v-slot:body>
						<!----- Listing length and search starts ----->
						<div class="row listing-length-row">
							<div class="col-sm-12 col-md-6">
								<div class="listing-length" >
									<label
										>Show
										<select class="form-control" v-model="listing_length" @change="fetchSessions()">
											<option value="5">5</option>
											<option value="10">10</option>
											<option value="15">15</option>
										</select>
										entries
									</label>
								</div>								
							</div>
							<div class="col-sm-12 col-md-6">
								<div class="div-search">
									<label>
										<input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchSessions()" />
									</label>
								</div>							
								
							</div>
						</div>
						<!----- Listing length and search ends ----->

						<!--- Listing starts ----->
						<div class="table-responsive">
							<table id="datatable" class="table data-table table-striped table-bordered dataTable">
								<thead>
									<tr>
										<th width="10%">Session Start</th>			
										<th width="10%">Session End</th>
										<th width="10%">Duration<br>(in years)</th>
										<th width="15%">Created on</th>
										<th width="10%">Options</th>
									</tr>
								</thead>
								<tbody v-if="Boolean(sessions.length)">
									<tr v-for="session in sessions" :key="session.id">
										<td>{{ session.start }}</td>
										<td>{{ session.end }}</td>
										<td>{{ session.session_duration }}</td>
										<td>{{ session.created_at | formatDateTime }}</td>
										<td>
											<b-button variant="primary" class="btn btn-sm mt-2 mr-1" @click="editSession(session)">Edit</b-button>
											
											<b-button variant="danger" class="btn mt-2 mr-1 btn-sm" @click="deactivateSession(session)" v-if="session.status == 1">Unpublish</b-button>
											<b-button variant="success" class="btn mt-2 mr-1 btn-sm" @click="activateSession(session)" v-else>Publish</b-button>
										</td>
									</tr>									
								</tbody>
								<tbody v-else>
									<tr>
										<td colspan="5" class="text-center">No data found!</td>
									</tr>
								</tbody>
							</table>
						</div>
						<!-- Listing ends -->
						<!---- modal starts ---->
						<b-modal ref="session-modal" id="session-modal" :title="modal_title" hide-footer @hidden="clearForm()">
							<b-form @submit.prevent="addSession">
								
								<b-col md="12" class="form-group">
									<label class="control-label">Start Year<span class="required">*</span></label>
									<b-form-input v-model="session.start" v-bind:class="{ 'is-invalid': Boolean(errors.start) }"></b-form-input>
									<div v-for="(val, index) in errors.start" :key="index" class="invalid-feedback">
										<p class="mb-0">{{ val }}</p>
									</div>
								</b-col>

								<b-col md="12" class="form-group">
									<label class="control-label">End Year<span class="required">*</span></label>
									<b-form-input v-model="session.end" v-bind:class="{ 'is-invalid': Boolean(errors.end) }"></b-form-input>
									<div v-for="(val, index) in errors.end" :key="index" class="invalid-feedback">
										<p class="mb-0">{{ val }}</p>
									</div>
								</b-col>

								<!-- <b-col md="12" class="form-group">
									<label class="control-label">Duration<span class="required">*</span></label>
									<b-form-input v-model="session.duration" v-bind:class="{ 'is-invalid': Boolean(errors.duration) }"></b-form-input>
									<div v-for="(val, index) in errors.duration" :key="index" class="invalid-feedback">
										<p class="mb-0">{{ val }}</p>
									</div>
								</b-col>
								
								 -->
								<b-col md="12">
									<b-button type="submit" class="mr-3" variant="primary">{{ button_title }}</b-button>
									<b-button class="" variant="light" @click="hideModal('session-modal')">Close</b-button>
								</b-col>
							</b-form>
						</b-modal>
						<!---- modal ends ----->
						<!----pagination starts --->
						<nav aria-label="Page navigation">
							<ul class="pagination">
								<li class="page-item" v-bind:class="[{ disabled: !page.url }, { active: page.active }]" v-for="(page, index) in pagination" :key="page.label">
									<a class="page-link" href="#" @click.prevent="fetchSessions(page.url + '&limit=' + listing_length + '&keyword=' + keyword)" tabindex="-1">
										<span v-if="index == 0">Prev</span>
										<span v-else-if="index == pagination.length - 1">Next</span>
										<span v-else>{{ page.label }}</span>
									</a>
								</li>
							</ul>
						</nav>
						<!----pagination ends --->
					</template>
				</card>
			</b-col>
		</b-row>
	</b-container>
</template>
<script>
export default {
	name: "Sessions",
	data() {
		return {
			sessions: [],
			session: {
				id: null,
			   	start: "",
			   	end: "",
			   	// duration: "",
			},
			
			modal_title: "Add Session",
			button_title: "Save",
			pagination: {},
			edit: false,
			session_status: {
				id: "",
				status: "",
			},
			keyword: "",
			showsearch: false,
			listing_length: 10,
			status: '',
			token: "",
			errors: {},
			activate: false,
         	deactivate: false,

         	active_page_url: null,
		};
	},
	mounted() {
			
	},

	created() {
		this.fetchSessions();
	},

		methods: {
		    
            getToken() {
				if (localStorage.token) {
					this.token = localStorage.token;
				} else {
					this.$vToastify.error("Session expired, please login again");
					this.$router.push({ name: "auth.login" });
				}
			},

			fetchSessions(page_url = null) 
			{
				let url = "/api/sessions/index?limit=" + this.listing_length + "&keyword=" + this.keyword;
				page_url = page_url || url;
				this.active_page_url = page_url;   
				this.getToken();
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						this.sessions   = responseData.data;
						this.pagination = responseData.links;
					})
					.catch((err) => console.log(err));
			},

			showModal(modal) {
				this.$refs[modal].show();
			},
            
            addSession() {
				this.getToken();
				let formData = new FormData();
				formData.append("start", this.session.start);
				formData.append("end", this.session.end);
				const config = {
					headers: {
						"content-type": "multipart/form-data",
						Authorization: "Bearer " + this.token,
					},
				};
				let url;
				if (!this.edit) {
					url = "/api/sessions/add";
					this.active_page_url = null;
				} else {
					url = "/api/sessions/update";
					formData.append("session_id", this.session.id);
				}
				this.$axios
					.post(url, formData, config)
					.then((response) => {
						if (response.data.status) {
							this.$vToastify.success(response.data.message);
						} else {
							this.$vToastify.error(response.data.message);
						}
						this.clearForm();
						this.hideModal("session-modal");
						this.fetchSessions(this.active_page_url);
					})
					.catch((error) => {
						console.log(error.response.data);
						if (error.response) {
							if (error.response.data.message) {
								this.errors = error.response.data.message;
								this.$vToastify.error(error.response.message);
							} else {
								this.$vToastify.error("Error!");
							}
						} else {
							this.$vToastify.error("Error!");
						}
					});
			},

			hideModal(modal) {
				this.$refs[modal].hide();
			},

			editSession(session) {
			    this.edit = true;
				this.session.id = session.id;
				this.session.start = session.start;
				this.session.end = session.end;
				this.errors = {};				
				this.modal_title = "Edit Session";
				this.button_title = "Update";				
				this.showModal("session-modal");
			},
			clearForm() {								
				this.modal_title = "Add Session";
				this.button_title = "Add";
                this.edit = false;
				this.session.start = "";
				this.session.end = "";
			},
			
			activateSession(session) {
				this.activate = false;
		        this.$bvModal.msgBoxConfirm('Are you sure you want to publish this session?', {
		            title: 'Confirm',
		            size: 'sm',
		            buttonSize: 'sm',
		            okVariant: 'danger',
		            okTitle: 'Yes',
		            cancelTitle: 'No',
		            footerClass: 'p-2',
		            hideHeaderClose: false,
		            centered: true
		        })
		        .then(value => {
		            this.activate = value
		            if(this.activate){
						this.session_status.id = session.id;
						this.session_status.status = "1";
						this.updateSessionStatus();
					}
		        })
		         .catch(err => {
		            console.log(err);
		        })
			},
			deactivateSession(session) {
				this.deactivate = false;
		        this.$bvModal.msgBoxConfirm('Are you sure you want to unpublish this session?', {
		            title: 'Confirm',
		            size: 'sm',
		            buttonSize: 'sm',
		            okVariant: 'danger',
		            okTitle: 'Yes',
		            cancelTitle: 'No',
		            footerClass: 'p-2',
		            hideHeaderClose: false,
		            centered: true
		        })
		         .then(value => {
		            this.deactivate = value
		            if(this.deactivate){
						this.session_status.id = session.id;
						this.session_status.status = "0";
						this.updateSessionStatus();
					}
         		})
         		.catch(err => {
           			console.log(err);
         		})
			},
			updateSessionStatus() {
				const config = {
					headers: {
						Authorization: "Bearer " + this.token,
					},
				};
				this.$axios
					.get("/api/sessions/status?session_id=" + this.session_status.id + "&status=" + this.session_status.status, config)
					.then((response) => {
						if (response.data.status) {
							this.$vToastify.success(response.data.message);
						} else {
							this.$vToastify.error(response.data.message);
						}
						this.fetchSessions(this.active_page_url);
					})
					.catch((error) => {
						if (error.response) {
							if (error.response.data.message) {
								this.$vToastify.error(error.response.message);
							} else {
								this.$vToastify.error("Error!");
							}
						} else {
							this.$vToastify.error("Error!");
						}
					});
			},
		},	
};
</script>
